var _g, _circle, _circle2, _circle3, _g2, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 373,
    viewBox: "0 0 390 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2093)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 210,
    r: 123,
    stroke: "#EDF1F4",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 200,
    r: 107,
    fill: "#33B1B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 200,
    r: 124,
    stroke: "#33B1B2",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 206,
    r: 124,
    stroke: "#33B1B2",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_2093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.981 216.283H204.72V124.168L299.672 124.002L346.981 191.336V216.283Z",
    fill: "#D3B24B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.372 245.153V128.34H282.15L342.559 214.615V245.153H192.372Z",
    fill: "#FED65C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.981 132.512L338.387 215.95V240.981H196.543V132.512H279.981V132.512ZM284.32 124.168H188.2V249.325H346.731V213.28L345.313 211.11L286.906 127.673L284.403 124.168H284.32Z",
    fill: "#D3B24B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.278 245.153V202.016C117.278 199.41 118.032 196.86 119.447 194.673L149.985 149.7C150.898 148.308 152.132 147.156 153.585 146.342C155.038 145.529 156.665 145.078 158.329 145.028H192.288V245.153H117.278Z",
    fill: "#EA8536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.329 149.2H188.116V240.981H121.366V202.016C121.361 200.235 121.884 198.493 122.868 197.009L153.406 152.037C153.987 151.173 154.769 150.464 155.685 149.97C156.6 149.476 157.622 149.212 158.663 149.2H158.329ZM158.663 140.856C156.159 140.848 153.695 141.48 151.505 142.692C149.314 143.904 147.47 145.656 146.147 147.781L115.693 192.337C113.725 195.207 112.704 198.62 112.772 202.099V241.064V249.408H196.21V140.939H158.329L158.663 140.856Z",
    fill: "#CF6614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.556 149.2H213.231V132.512H279.981L338.387 215.95V224.293H321.7L273.556 149.2ZM302.426 132.512H287.908L299.672 149.2H314.107L302.426 132.512ZM319.113 157.543H304.762L316.527 174.231H330.961L319.113 157.543Z",
    fill: "#FBEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.751 264.594C292.665 264.594 289.648 263.679 287.082 261.964C284.516 260.25 282.516 257.813 281.336 254.962C280.155 252.111 279.846 248.974 280.448 245.947C281.05 242.92 282.536 240.14 284.718 237.958C286.9 235.776 289.68 234.29 292.707 233.688C295.733 233.086 298.871 233.395 301.722 234.576C304.573 235.757 307.009 237.757 308.724 240.323C310.438 242.888 311.353 245.905 311.353 248.991C311.353 253.129 309.71 257.098 306.784 260.024C303.857 262.95 299.889 264.594 295.751 264.594V264.594Z",
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.751 239.563C297.599 239.563 299.406 240.111 300.942 241.137C302.479 242.164 303.677 243.624 304.384 245.331C305.092 247.039 305.277 248.918 304.916 250.731C304.556 252.543 303.665 254.208 302.359 255.515C301.052 256.822 299.387 257.712 297.574 258.073C295.761 258.434 293.882 258.248 292.174 257.541C290.467 256.834 289.007 255.636 287.981 254.099C286.954 252.563 286.406 250.756 286.406 248.908C286.406 246.429 287.39 244.052 289.143 242.3C290.895 240.547 293.272 239.563 295.751 239.563V239.563ZM295.751 227.047C291.427 227.047 287.201 228.329 283.606 230.731C280.011 233.133 277.209 236.547 275.554 240.542C273.899 244.536 273.467 248.932 274.31 253.172C275.154 257.413 277.236 261.308 280.293 264.365C283.35 267.423 287.245 269.505 291.486 270.348C295.726 271.192 300.122 270.759 304.116 269.104C308.111 267.45 311.525 264.648 313.927 261.053C316.329 257.458 317.611 253.231 317.611 248.908C317.611 243.11 315.308 237.549 311.208 233.45C307.109 229.35 301.548 227.047 295.751 227.047V227.047Z",
    fill: "#293B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.607 264.594C244.521 264.594 241.505 263.679 238.939 261.964C236.373 260.25 234.373 257.813 233.192 254.962C232.011 252.111 231.702 248.974 232.304 245.947C232.906 242.92 234.392 240.14 236.574 237.958C238.756 235.776 241.537 234.29 244.563 233.688C247.59 233.086 250.727 233.395 253.578 234.576C256.429 235.757 258.866 237.757 260.58 240.323C262.295 242.888 263.21 245.905 263.21 248.991C263.21 253.129 261.566 257.098 258.64 260.024C255.714 262.95 251.745 264.594 247.607 264.594V264.594Z",
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.607 239.563C249.455 239.563 251.262 240.111 252.799 241.137C254.336 242.164 255.534 243.624 256.241 245.331C256.948 247.039 257.133 248.918 256.773 250.731C256.412 252.543 255.522 254.208 254.215 255.515C252.908 256.822 251.243 257.712 249.43 258.073C247.618 258.434 245.739 258.248 244.031 257.541C242.323 256.834 240.864 255.636 239.837 254.099C238.81 252.563 238.262 250.756 238.262 248.908C238.262 246.429 239.247 244.052 240.999 242.3C242.752 240.547 245.129 239.563 247.607 239.563V239.563ZM247.607 227.047C243.284 227.047 239.057 228.329 235.462 230.731C231.867 233.133 229.065 236.547 227.411 240.542C225.756 244.536 225.323 248.932 226.167 253.172C227.01 257.413 229.092 261.308 232.149 264.365C235.207 267.423 239.102 269.505 243.342 270.348C247.583 271.192 251.978 270.759 255.973 269.104C259.967 267.45 263.382 264.648 265.784 261.053C268.186 257.458 269.468 253.231 269.468 248.908C269.468 246.037 268.902 243.194 267.804 240.542C266.705 237.89 265.095 235.48 263.065 233.45C261.035 231.42 258.625 229.81 255.973 228.711C253.321 227.612 250.478 227.047 247.607 227.047V227.047Z",
    fill: "#293B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.482 264.594C144.396 264.594 141.38 263.679 138.814 261.964C136.248 260.25 134.248 257.813 133.067 254.962C131.886 252.111 131.577 248.974 132.179 245.947C132.781 242.92 134.267 240.14 136.449 237.958C138.631 235.776 141.412 234.29 144.438 233.688C147.465 233.086 150.602 233.395 153.453 234.576C156.304 235.757 158.741 237.757 160.455 240.323C162.17 242.888 163.085 245.905 163.085 248.991C163.085 253.129 161.441 257.098 158.515 260.024C155.589 262.95 151.62 264.594 147.482 264.594V264.594Z",
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.482 239.563C149.33 239.563 151.137 240.111 152.674 241.137C154.211 242.164 155.409 243.624 156.116 245.331C156.823 247.039 157.008 248.918 156.648 250.731C156.287 252.543 155.397 254.208 154.09 255.515C152.783 256.822 151.118 257.712 149.305 258.073C147.493 258.434 145.614 258.248 143.906 257.541C142.198 256.834 140.739 255.636 139.712 254.099C138.685 252.563 138.137 250.756 138.137 248.908C138.137 246.429 139.122 244.052 140.874 242.3C142.627 240.547 145.004 239.563 147.482 239.563V239.563ZM147.482 227.047C143.159 227.047 138.932 228.329 135.337 230.731C131.742 233.133 128.94 236.547 127.286 240.542C125.631 244.536 125.198 248.932 126.042 253.172C126.885 257.413 128.967 261.308 132.024 264.365C135.082 267.423 138.977 269.505 143.217 270.348C147.458 271.192 151.853 270.759 155.848 269.104C159.842 267.45 163.257 264.648 165.659 261.053C168.061 257.458 169.343 253.231 169.343 248.908C169.343 243.11 167.04 237.549 162.94 233.45C158.84 229.35 153.28 227.047 147.482 227.047V227.047Z",
    fill: "#293B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.512 190.918H116.61L139.222 157.543H171.512V190.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.706 190.918H116.61L139.222 157.543H149.318L126.706 190.918Z",
    fill: "#CAD0D8"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 66,
    r: 4,
    fill: "#EA8536"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 120,
    r: 4,
    fill: "#EA8536"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 284,
    r: 4,
    fill: "#33B1B2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 103,
    r: 4,
    fill: "#33B1B2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 257,
    r: 4,
    fill: "#33B1B2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 331,
    r: 4,
    fill: "#33B1B2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 340,
    r: 4,
    fill: "#33B1B2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 36,
    r: 4,
    fill: "#33B1B2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 48,
    r: 4,
    fill: "#33B1B2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 24,
    r: 4,
    fill: "#EA8536"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 200,
    r: 4,
    fill: "#EA8536"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 289,
    r: 4,
    fill: "#EA8536"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 348,
    r: 4,
    fill: "#EA8536"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 335,
    r: 4,
    fill: "#EA8536"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2093",
    x: 65,
    y: 79,
    width: 274,
    height: 274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_2093",
    x: 100.769,
    y: 118.002,
    width: 258.212,
    height: 170.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2093",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.38b6ee6021324d25662538e042df9812.svg";
export { ForwardRef as ReactComponent };